var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeroUnlimitedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 21.4 21.4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 633183"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 8955",
    d: "M15.7003 11.5333L15.7003 5.70028C15.7003 2.9387 13.4614 0.7 10.6998 0.7C7.93841 0.7 5.69969 2.93858 5.69969 5.7",
    stroke: "var(--stroke-0, white)",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 8956",
    d: "M5.69974 9.86666L5.69974 15.6997C5.69974 18.4613 7.93859 20.7 10.7002 20.7C13.4616 20.7 15.7003 18.4614 15.7003 15.7",
    stroke: "var(--stroke-0, white)",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 8957",
    d: "M11.5333 5.69944L5.70028 5.69944C2.9387 5.69944 0.7 7.93837 0.7 10.6999C0.7 13.4613 2.9385 15.7 5.69983 15.7",
    stroke: "var(--stroke-0, white)",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 8958",
    d: "M9.86667 15.7006L15.6997 15.7006C18.4613 15.7006 20.7 13.4618 20.7 10.7002C20.7 7.93871 18.4613 5.7 15.6998 5.7",
    stroke: "var(--stroke-0, white)",
    strokeWidth: 1.4,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroUnlimitedIcon);
export default __webpack_public_path__ + "static/media/hero-unlimited-icon.7143cba96ca67f6d79533dcbd3ea6ca5.svg";
export { ForwardRef as ReactComponent };